export default "__VITE_ASSET__Oa6MUIJN__"